var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",value:(_vm.tooltip),expression:"tooltip",modifiers:{"hover":true,"top":true}}],staticClass:"match-alert-beacon",style:({ backgroundColor: _vm.color })})
}
var staticRenderFns = []

export { render, staticRenderFns }